import isCanAccess from '../helpers/Auth/isCanAccess'
import { useAuth } from '../composables/useAuth'


async function guard(to: any, from: any, router: any, storeAuth: any) {
  const { status, user, logout } = storeAuth()

  if (user?.permission) {
    const isAuth = isCanAccess(to, user)

    const routePermission = user.permission[1] === 'Logout' || user.permission[1] === 'Companias' ? user.permission[2] : user.permission[1]

    if (!isAuth) {
      router.push({ name: routePermission });
    }
  }

  if (!status && to.meta.gate) {
    try {
      const { handleAuthenticated } = useAuth()
      const isAuthenticate = await handleAuthenticated()

      if (isAuthenticate?.user) {
        const isAuth = isCanAccess(to, isAuthenticate.user)
        const routePermission = isAuthenticate.user.permission[1] === 'Logout' || isAuthenticate.user.permission[1] === 'Companias' ? isAuthenticate.user.permission[2] : isAuthenticate.user.permission[1]

        if (!isAuth) {
          if (routePermission) {
            router.push({ name: routePermission });
          } else {
            logout()
            router.push({ name: 'Login' });
          }
        }
      }

      if (!isAuthenticate || isAuthenticate.error) {
        router.push({ name: 'Login' });
      }

    } catch (error) {
      router.push({ name: 'Login' });
    }
  }

}

export default guard;
